interface RankingItem {
  rank: number;
  title: string;
  hot: string;
  trend: 'up' | 'down' | 'new';
}

const rankingItems: RankingItem[] = [
  {
    rank: 1,
    title: '某顶流深夜密会神秘女子事件持续发酵，多方出面回应',
    hot: '128万热度',
    trend: 'up',
  },
  {
    rank: 2,
    title: '知名导演片场发飙视频流出，业内人士曝更多内幕',
    hot: '96万热度',
    trend: 'up',
  },
  {
    rank: 3,
    title: '某当红女星隐婚生子传闻，丈夫身份引发全网猜测',
    hot: '89万热度',
    trend: 'new',
  },
  {
    rank: 4,
    title: '网红直播间爆料行业黑幕，多条产业链被起底',
    hot: '75万热度',
    trend: 'up',
  },
  {
    rank: 5,
    title: '两大顶流番位之争持续升级，粉丝互撕进入白热化',
    hot: '68万热度',
    trend: 'down',
  },
  {
    rank: 6,
    title: '某选秀冠军投票造假疑云，粉丝要求第三方审计',
    hot: '62万热度',
    trend: 'up',
  },
  {
    rank: 7,
    title: '影视圈寒冬裁员潮蔓延，多部新剧宣布延拍',
    hot: '54万热度',
    trend: 'new',
  },
];

const trendIcon = (trend: string) => {
  if (trend === 'up') return 'ri-arrow-up-line text-primary-500';
  if (trend === 'down') return 'ri-arrow-down-line text-foreground-400';
  return 'ri-sparkling-line text-accent-500';
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时热度排行，看看今天哪颗瓜最受吃瓜群众关注
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-3">
            {rankingItems.map((item, idx) => (
              <div
                key={idx}
                className="group flex items-center gap-4 bg-background-50 border border-background-200/70 rounded-xl p-3 md:p-4 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div
                  className={`w-9 h-9 md:w-10 md:h-10 rounded-xl flex items-center justify-center flex-shrink-0 font-heading text-base md:text-lg ${
                    idx < 3
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-400">{item.hot}</span>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={trendIcon(item.trend)}></i>
                    </div>
                  </div>
                </div>

                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}